/**
 * CERTIFICATION BEFORE GA (EXPERT-ROOMS.md §11, E8 X7) — in an expert team's LEAD room: the checklist for the
 * network's current release. After the live sandbox run, the workspace OWNER confirms every step + names the run(s);
 * only a certified release publishes to the Registry. Additive section.
 */
import React, { useState } from 'react';

const btn = 'px-2.5 py-1 text-xs font-medium rounded-md transition-colors';

export default function RoomCertification({ value, onCertify }) {
  const v = value || {};
  const [checked, setChecked] = useState({});
  const [runs, setRuns] = useState('');
  const [notes, setNotes] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const steps = v.steps || [];
  const all = steps.length > 0 && steps.every((s) => checked[s.step]);
  const certify = async () => {
    setBusy(true); setErr('');
    try {
      await onCertify({ checklist: checked, runs: runs.split(/[\s,]+/).filter(Boolean), notes });
    } catch (e) { setErr(e?.message || "Couldn't certify."); }
    setBusy(false);
  };
  return (
    <div className="space-y-2 text-[12px]" data-testid="room-certification">
      <p className="text-[11px] text-gray-700" data-testid="certification-status">
        Release v{v.release || '—'}: {v.certified ? 'certified' : 'not certified yet'}
        {v.onFile && !v.certified ? ` (the certificate on file is for v${v.onFile.release})` : ''}
        {v.certified && v.onFile ? ` — by ${v.onFile.by}` : ''}
      </p>
      <p className="text-[11px] text-gray-500">An Expert Network publishes to the Registry only after its release is
        proven: the offline simulation passes and a live run on a sandbox confirms each step.</p>
      {!v.certified && v.canCertify ? (
        <>
          {steps.map((s) => (
            <label key={s.step} className="flex items-start gap-2 text-[11px]">
              <input type="checkbox" checked={!!checked[s.step]} disabled={busy} data-testid={`cert-step-${s.step}`}
                onChange={(e) => setChecked({ ...checked, [s.step]: e.target.checked })} />
              <span>{s.label}</span>
            </label>
          ))}
          <label className="block text-[11px] font-medium text-gray-700">The sandbox run id(s)
            <input value={runs} onChange={(e) => setRuns(e.target.value)} disabled={busy} data-testid="cert-runs"
              className="mt-0.5 block w-full rounded-md border border-gray-300 px-2 py-1 text-xs" />
          </label>
          <label className="block text-[11px] font-medium text-gray-700">Notes
            <textarea rows={2} value={notes} onChange={(e) => setNotes(e.target.value)} disabled={busy}
              className="mt-0.5 block w-full rounded-md border border-gray-300 px-2 py-1 text-xs" />
          </label>
          <button type="button" disabled={busy || !all || !runs.trim()} data-testid="cert-submit"
            className={`${btn} bg-indigo-600 text-white hover:bg-indigo-700 disabled:opacity-50`} onClick={certify}>
            Certify v{v.release}</button>
        </>
      ) : null}
      {!v.certified && !v.canCertify ? (
        <p className="text-[11px] text-gray-500">The workspace owner certifies it after the live sandbox run.</p>
      ) : null}
      {err ? <p className="text-[11px] text-rose-600">{err}</p> : null}
    </div>
  );
}
